var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { createSlice } from '@reduxjs/toolkit';
var initialState = {
    pending: false,
    todos: [],
    error: null,
};
var todoSlice = createSlice({
    name: 'todo',
    initialState: initialState,
    reducers: {
        fetchTodoRequest: function (state) {
            return __assign(__assign({}, state), { pending: true });
        },
        fetchTodoSuccess: function (state, action) { return (__assign(__assign({}, state), { pending: false, todos: action.payload.todos, error: null })); },
        fetchTodoFailed: function (state, action) { return (__assign(__assign({}, state), { pending: false, todos: [], error: action.payload.error })); },
    },
});
export var fetchTodoRequest = (_a = todoSlice.actions, _a.fetchTodoRequest), fetchTodoSuccess = _a.fetchTodoSuccess, fetchTodoFailed = _a.fetchTodoFailed;
export default todoSlice.reducer;
